import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Flex,
  Input,
  Typography,
  List,
  Row,
  Col,
  Spin,
  Alert,
} from "antd";
import { InsertRowLeftOutlined } from "@ant-design/icons";

import { createService } from "../../redux/tradeSlice";

const { Title } = Typography;

const  AdminServices = () => {
  const [serviceName, setServiceName] = useState("");

  const { organizationData } = useSelector((state) => state.organization);
  const {services, loading } = useSelector((state) => state.trade);

  const dispatch = useDispatch();

  const addService = () => {
    if (serviceName) {
      dispatch(
        createService({ serviceName})
      );
    }
  };

  return (
    <>
      <Spin spinning={loading} fullscreen />
      <Flex align="center" gap={10} style={{ marginBottom: "50px" }}>
        <InsertRowLeftOutlined style={{ fontSize: 20 }} />
        <Title level={3} style={{ margin: 0 }}>
        Service Types
        </Title>
      </Flex>
      <Row>
        <Col span={6}>
          <Flex vertical={true} gap={20}>
            <Input
              placeholder="Add New Service"
              value={serviceName}
              onChange={(e) => setServiceName(e.target.value)}
              size="large"
            />
            <Button
              type="primary"
              onClick={addService}
              disabled={serviceName.trim() === ""}
              size="large"
              style={{ width: "fit-content" }}
            >
              Submit
            </Button>
          </Flex>
        </Col>
      </Row>

      <br />
      <Alert
        style={{ padding: "0.5rem", marginBottom: "0.5rem" }}
        message={
          <div>
            <span>
              This will just create Service. For this new Service to show in your organization's{" "}
              <strong>Trade & Service and Offerings.</strong>
            </span>{" "}
            <span>
              You need to first time activate it from{" "}
              <strong>Activate Services</strong> in{" "}
              <strong>Organization Navigation Flows</strong>.
            </span>
          </div>
        }
        type="info"
        showIcon
      />

      <Flex style={{ margin: "25px 0px" }}>
        <Title level={3}>Offered Service Types</Title>
      </Flex>

      <List
        size="large"
        bordered
        dataSource={services?.length>0?services:[]}
        renderItem={(item) => (
          <List.Item key={item?._id}>
            <List.Item.Meta title={item?.name} />
          </List.Item>
        )}
      />
    </>
  );
};

export default AdminServices;